//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.ToolAxisBase.js";
let d=[[[0,"IsPreferredAnglesDefined",0,0],[0,"PreferredFifthAngle",0,0],[0,"PreferredFourthAngle",0,0],[0,"TangentToCurveAngle",1,0],[0,"ToolAxisType",1,0]],[],[]];
SPLM.CAM.ToolAxisFixed = class extends SPLM.CAM.ToolAxisBase{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolAxisFixed";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolAxisFixed.Types = Object.freeze({
    "None" : "None", "Fixed" : "Fixed", "NormalToPart" : "NormalToPart", "NormalToFirstFace" : "NormalToFirstFace", "Dynamic" : "Dynamic", "TangentToCurve" : "TangentToCurve", "TangentToCurveAtAngle" : "TangentToCurveAtAngle"});

export default SPLM;